import React, { useState } from "react";
import EventMltMap from './EventMltMap';
import ListModal from '../../components/ListModal';
import 'react-datepicker/dist/react-datepicker.css';
import LeftContainerEventMlt from "../Eventmlt.jsx/LeftContainerEventMlt";
import RightContainerEventMlt from "../Eventmlt.jsx/RightContainerEventMlt";

export default function EventMltVip2() {
  const [showModal, setShowModal] = useState(false);
  const [filteredEventDates, setFilteredEventDates] = useState([]);
  const [filters, setFilters] = useState({
    showHideAllPoints: true,
    UpComingEvents: true,
    EventsWithNewComments: true,
    EventSiteforOthers: true,
  });

  const [showAll, setShowAll] = useState(true);
  const firstName = localStorage.getItem('firstName');
  const lastName = localStorage.getItem('lastName');
  
  const toggleModal = () => setShowModal(!showModal);
  const toggleShowAll = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  const handleFilterChange = (event) => {
    const { id, checked } = event.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [id]: checked,
    }));
  };

  return (
    <div className="container-fluid">
      <div className="row m-2">
        <div className="col-md-3 mt-1 mb-3 bg-light rounded">
          <div className="p-2 text-blue bg-light">
            <div className="font-700" style={{ fontSize: 18 }}>
              <span style={{ color: "rgba(0, 215, 185, 1)" }}>Welcome</span>
              <br />
              {lastName}, {firstName}
            </div>
            <div className="mt-3 font-800 text-uppercase" style={{ fontSize: 14 }}>
              MY POINTS OF INTERESTS
            </div>
            <div className="mt-2 d-flex flex-column text-blue2" style={{ fontSize: 12 }}>
              <div className="align-items-center mb-2 d-flex">
                <input className="form-check-input-custom2 form-check-input" type="checkbox" id="showHideAllPoints" checked={showAll} onChange={toggleShowAll} />
                <span className="font-mars-centra">Show/Hide all points</span>
              </div>
              {showAll && (
                <>
                  <div className="d-flex align-items-center mb-2">
                    <input className="form-check-input-custom2 form-check-input" type="checkbox" id="UpComingEvents" checked={filters.UpComingEvents} onChange={handleFilterChange} />
                    <span className="ml-2 font-mars-centra"> Upcoming Events</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <input className="form-check-input-custom2 form-check-input" type="checkbox" id="EventsWithNewComments" checked={filters.EventsWithNewComments} onChange={handleFilterChange} />
                    <span className="ml-2 font-mars-centra">Events with new Comments</span>

                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <input className="form-check-input-custom2 form-check-input" type="checkbox" id="EventSiteforOthers" checked={filters.EventSiteforOthers} onChange={handleFilterChange} />
                    <span className="ml-2 font-mars-centra">Events site for other</span>
                  </div>
                </>)}
            </div>
          </div>
        </div>
        <div className="col-md-9 mt-1 mb-3 rounded">
          <EventMltMap filters={filters} />
        </div>
      </div>
      <div className="progress d-flex flex-column" style={{ backgroundColor: 'gainsboro', height: '100%' }}>
        <div className="row">
          <div className="col-md-8">
            <LeftContainerEventMlt
              setFilteredEventDates={setFilteredEventDates}
              filters={filters}
            />
          </div>
          <div className="col-md-4">
            <RightContainerEventMlt eventDates={filteredEventDates} />
          </div>
        </div>
      </div>
      <ListModal showModal={showModal} toggleModal={toggleModal} />
    </div>
  );
}
